/**
 * Guard frontend para rutas /platform/* (Sprint BB · ADR-032).
 *
 * Si el usuario no tiene role='super_admin' en session redirige a /clients.
 * Se compone con RequireFullAuth para garantizar que la session esté completa.
 */
import { type ReactNode } from 'react';
import { Navigate } from 'react-router-dom';

import { useAuth } from './AuthContext.js';

interface Props {
  children: ReactNode;
}

export function RequirePlatformAdmin({ children }: Props): JSX.Element {
  const { session } = useAuth();

  if (session?.user?.role !== 'super_admin') {
    return <Navigate to="/clients" replace />;
  }

  return <>{children}</>;
}
